import {Suspense, useEffect} from 'react'
import {Outlet} from 'react-router-dom'
import {LayoutProvider, LayoutSplashScreen} from '../_metronic/layout/core'
import {MasterInit} from '../_metronic/layout/MasterInit'
import {AuthInit} from './modules/auth'
import {ThemeModeProvider} from '../_metronic/partials'
import {ToastContainer} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import {useTranslation} from 'react-i18next'

const App = () => {
  const {i18n} = useTranslation()
  const lang = i18n.language

  const loadStyle = (href: string) => {
    const existingLink = document.getElementById('dynamic-style')
    if (existingLink) {
      existingLink.parentNode?.removeChild(existingLink)
    }

    const link = document.createElement('link')
    link.rel = 'stylesheet'
    link.href = `${process.env.PUBLIC_URL}/${href}` // always from public root
    link.id = 'dynamic-style'
    document.head.appendChild(link)
  }

  useEffect(() => {
    const htmlTag = document.documentElement

    if (lang === 'dr' || lang === 'pa') {
      loadStyle('css/style.rtl.css')
      htmlTag.setAttribute('dir', 'rtl')
      htmlTag.style.direction = 'rtl'
    } else {
      loadStyle('css/style.css')
      htmlTag.removeAttribute('dir')
      htmlTag.style.removeProperty('direction')
    }
  }, [lang])

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <LayoutProvider>
        <ThemeModeProvider>
          <AuthInit>
            <Outlet />
            <MasterInit />

            <ToastContainer
              position='top-right'
              autoClose={3000}
              hideProgressBar={false}
              newestOnTop
              closeOnClick
              rtl={lang === 'en' ? false : true}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme='colored'
            />
          </AuthInit>
        </ThemeModeProvider>
      </LayoutProvider>
    </Suspense>
  )
}

export {App}
